import { SourceType } from '@kanbu/schema/enums';
import { useLingui } from '@lingui/react/macro';
import { Cloud, Globe, Rss, Upload, type LucideIcon } from 'lucide-react';
import { useMemo } from 'react';

export type SourceTypeMeta = {
  label: string;
  icon: LucideIcon;
};

/** Badge label + icon per source origin. K2/K3 only add copy here. */
export function useSourceTypeLabels(): Record<SourceType, SourceTypeMeta> {
  const { t } = useLingui();

  return useMemo(
    () => ({
      [SourceType.Upload]: { label: t`Upload`, icon: Upload },
      [SourceType.Website]: { label: t`Website`, icon: Globe },
      [SourceType.GoogleDrive]: { label: t`Google Drive`, icon: Cloud },
      [SourceType.Rss]: { label: t`RSS feed`, icon: Rss },
    }),
    [t],
  );
}
